'use client';
import React, { useState } from 'react';
import { getFlatRegions } from '../../utils/parks/getters';
import { Button, Size, Theme } from '../Button';
import Grid from '../Grid';
import styles from './caravanSalesSearchForm.module.scss';
import horizontalStyles from './horizontal.module.scss';
import SearchActionButton from './children/action-button';
import SearchInputOrParkSelector from './children/search-input';
import Heading from '../Heading';
const flatRegions = getFlatRegions('ownership');
const Horizontal = ({ title, children }) => (<div id='csSearchForm' className={horizontalStyles.caravanSalesSearchForm}>
    {title && (<Heading className={horizontalStyles.title} scale={2} level={2}>
        {title}
      </Heading>)}
    <div className={horizontalStyles.search}>{children}</div>
  </div>);
export const CaravanSalesSearchForm = (props) => {
    const { title, onSubmit, secondaryButtonAction, secondaryButtonLabel, theme, fullwidthMode = false, selectedRegion, showFeaturedPromo, } = props;
    const regionSelection = selectedRegion
        ? flatRegions.filter(({ code }) => code.includes(selectedRegion))
        : flatRegions;
    const selectedParkIds = selectedRegion
        ? regionSelection.map(({ parkCodes }) => parkCodes).flat()
        : [];
    // States
    const [selectedParks, setSelectedParks] = useState(new Set(selectedParkIds));
    const [hasError, setHasError] = useState(false);
    const onChangeHandler = (parks) => {
        if (parks.size > 0) {
            setSelectedParks(parks);
        }
        setHasError(parks.size === 0);
    };
    const onSubmitHandler = (parks) => {
        if (parks.size > 0 && !hasError) {
            onSubmit(parks);
        }
        setHasError(parks.size === 0);
    };
    if (fullwidthMode) {
        return (<Horizontal {...props}>
        <SearchInputOrParkSelector parks={selectedParks} onParkChange={(parks) => {
                onChangeHandler(new Set(parks));
            }} className={horizontalStyles.searchInput} regionSelection={regionSelection} onSubmit={() => onSubmitHandler(selectedParks)} error={hasError} showFeaturedPromo={showFeaturedPromo}/>
        <Button scale={Size.LARGE_SIZE} theme={theme || Theme.PRIMARY_THEME} onClick={() => onSubmitHandler(selectedParks)} className={horizontalStyles.action} disabled={hasError}>
          Search
        </Button>
      </Horizontal>);
    }
    return (<div id='csSearchForm' className={styles.caravanSalesSearchForm}>
      {title && <h1 className={styles.title}>{title}</h1>}
      <Grid.Row className={styles.search}>
        <SearchInputOrParkSelector parks={selectedParks} onParkChange={(parks) => {
            onChangeHandler(new Set(parks));
        }} className={styles.searchInput} regionSelection={regionSelection} error={hasError} showFeaturedPromo={showFeaturedPromo}/>
      </Grid.Row>
      <Grid.Row className={styles.actions}>
        <SearchActionButton lg={secondaryButtonAction ? 5.5 : 12} onSubmit={() => onSubmitHandler(selectedParks)} label='Search' errors={hasError}/>
        {secondaryButtonAction && (<SearchActionButton theme={theme || Theme.SECONDARY_THEME} label={secondaryButtonLabel || 'Book a call'} onSubmit={secondaryButtonAction} lg={5.5}/>)}
      </Grid.Row>
    </div>);
};
